export default (that) => [
  {
    text: that.$l('table_opt_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('table_opt_edit') || '编辑信息',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
  },
  // {
  //   text: that.$l('table_opt_delete') || '删除信息',
  //   icon: 'el-icon-delete',
  //   menuType: 'delete',
  //   divided: false,
  //   // allow: 'D',
  //   disabled: ({ status }) => !['N'].includes(status),
  // },
  // {
  //   text: that.$l('table_opt_audit') || '审核确认',
  //   icon: 'el-icon-check',
  //   menuType: 'audit',
  //   divided: true,
  //   // allow: 'C',
  //   disabled: ({ status }) => !['N'].includes(status),
  // }
]
